/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EstimateWorkflowState
 */
export interface EstimateWorkflowState {
    /**
     * 
     * @type {string}
     * @memberof EstimateWorkflowState
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EstimateWorkflowState
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateWorkflowState
     */
    insurerDocumentId: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateWorkflowState
     */
    contractorDocumentId: number;
    /**
     * 
     * @type {string}
     * @memberof EstimateWorkflowState
     */
    status: EstimateWorkflowStateStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof EstimateWorkflowState
     */
    insurerEstimateId?: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateWorkflowState
     */
    contractorEstimateId?: number;
    /**
     * 
     * @type {string}
     * @memberof EstimateWorkflowState
     */
    error?: string;
    /**
     * 
     * @type {Date}
     * @memberof EstimateWorkflowState
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EstimateWorkflowState
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EstimateWorkflowState
     */
    completedAt?: Date | null;
}


/**
 * @export
 */
export const EstimateWorkflowStateStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type EstimateWorkflowStateStatusEnum = typeof EstimateWorkflowStateStatusEnum[keyof typeof EstimateWorkflowStateStatusEnum];


/**
 * Check if a given object implements the EstimateWorkflowState interface.
 */
export function instanceOfEstimateWorkflowState(value: object): value is EstimateWorkflowState {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('insurerDocumentId' in value) || value['insurerDocumentId'] === undefined) return false;
    if (!('contractorDocumentId' in value) || value['contractorDocumentId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function EstimateWorkflowStateFromJSON(json: any): EstimateWorkflowState {
    return EstimateWorkflowStateFromJSONTyped(json, false);
}

export function EstimateWorkflowStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateWorkflowState {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'insurerDocumentId': json['insurerDocumentId'],
        'contractorDocumentId': json['contractorDocumentId'],
        'status': json['status'],
        'insurerEstimateId': json['insurerEstimateId'] == null ? undefined : json['insurerEstimateId'],
        'contractorEstimateId': json['contractorEstimateId'] == null ? undefined : json['contractorEstimateId'],
        'error': json['error'] == null ? undefined : json['error'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
    };
}

export function EstimateWorkflowStateToJSON(json: any): EstimateWorkflowState {
    return EstimateWorkflowStateToJSONTyped(json, false);
}

export function EstimateWorkflowStateToJSONTyped(value?: EstimateWorkflowState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claimId': value['claimId'],
        'insurerDocumentId': value['insurerDocumentId'],
        'contractorDocumentId': value['contractorDocumentId'],
        'status': value['status'],
        'insurerEstimateId': value['insurerEstimateId'],
        'contractorEstimateId': value['contractorEstimateId'],
        'error': value['error'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt'] as any).toISOString()),
    };
}

